@if (showNotification) {
  <div class="platium-notification">
    <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div class="flex flex-wrap items-center gap-2 text-base font-semibold text-dc-black">
        <span>
          {{
            "BG_DASH.PLATINUM_NOTIFICATION"
              | translate: { targetApplication: targetApplicationCount }
          }}
        </span>
        <span>
          <img src="/images/platinum-badge.png" />
        </span>
        <button
          type="button"
          class="text-dc-dark-blue font-semibold underline underline-offset-4 hover:no-underline"
          (click)="onViewBenefits()"
        >
          {{ "BG_DASH.VIEW_BENEFITS" | translate }}
        </button>
      </div>

      <div class="flex w-full items-center gap-3 lg:w-auto">
        <span class="whitespace-nowrap text-base font-semibold text-dc-black">
          {{
            "BG_DASH.PLATINUM_NOTIFICATION_TARGET"
              | translate
                : {
                    totalApplication: totalApplications,
                    targetApplication: targetApplicationCount,
                  }
          }}
        </span>
        <div class="h-2 w-full overflow-hidden rounded bg-white lg:w-23">
          <div
            class="h-full rounded bg-dc-blue"
            [ngStyle]="{ width: applicationPercentage + '%' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
}
